export default __webpack_public_path__ + "static/media/IMG_1297cropped.d1ae2cbc.jpeg";